import { ICrudLocale } from '@app/i18n/interface';

/**
 * Textos de «Previsión de cobro» (pago diferido, REQ-076..REQ-078). Como en Reservas: «la
 * reserva», en femenino, y tuteo informal (B-14, HB-182).
 */
export const PENDING_COLLECTION_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  PENDING_COLLECTION: {
    LABEL: {
      SINGULAR: 'Previsión de cobro',
      PLURAL: 'Previsión de cobro',
    },
    LIST: {
      TITLE: 'Reservas pendientes de pago',
      DESCRIPTION: 'Reservas hechas con «pagar después» que todavía no se han cobrado: cuánto se espera cobrar y hasta cuándo.',
      NO_DATA: 'No hay reservas pendientes de pago.',
      NO_DATA_FILTER: 'No hay reservas pendientes de pago con estos filtros.',
    },
    SUMMARY: {
      FORECAST_TITLE: 'Es una previsión, no un ingreso',
      FORECAST_DESC: 'Reservas confirmadas pendientes de pago. Algunas pueden cancelarse o no pagarse; el importe no está cobrado y no suma a la venta.',
      FORECAST_BADGE: 'Previsión',
      TOTAL: 'Total previsto por cobrar',
      TOTAL_NOTE: 'De todas las reservas que cumplen los filtros, sin las cancelaciones en curso.',
      COUNT: 'Reservas por cobrar',
      COUNT_NOTE: 'Sin las cancelaciones en curso.',
      CANCELLING: 'Cancelaciones en curso',
      CANCELLING_NOTE: '{{amount}} que no se van a cobrar: no suman al total.',
      FAILED_TITLE: 'No se pudo cargar la previsión',
      FAILED_DESC: 'Las cifras no se han cargado, así que no sabemos cuánto queda por cobrar. Recarga la página; si sigue, revisa la API.',
    },
    FILTER: {
      TITLE: 'Filtrar la previsión',
      SEARCH: 'Buscar',
      SEARCH_PLACEHOLDER: 'Referencia, cliente, correo u hotel',
      DUE_FROM: 'Fecha límite desde',
      DUE_TO: 'Fecha límite hasta',
      CHECK_IN_FROM: 'Entrada desde',
      CHECK_IN_TO: 'Entrada hasta',
      DATE_PLACEHOLDER: 'dd/mm/aaaa',
      DATE_INVALID: 'Escribe la fecha como dd/mm/aaaa.',
      INCLUDE_CANCELLATIONS: 'Incluir cancelaciones en curso',
      APPLY: 'Aplicar filtros',
      CLEAR: 'Limpiar',
      NOTE: 'Ordenadas por fecha límite, la más próxima arriba. En rojo, las que vencen en menos de 24 horas.',
    },
    FIELD: {
      ORDER: 'Reserva',
      NO_NUMBER: 'Sin número',
      CUSTOMER: 'Cliente',
      NO_CUSTOMER: 'Sin cliente',
      HOTELS: 'Hotel',
      DATES: 'Entrada – salida',
      AMOUNT: 'Importe',
      CANCELLING: 'Cancelación en curso',
      DEADLINE: 'Fecha límite',
      HOTEL_TIME: 'hora del hotel',
      UTC: '{{date}} UTC',
      DUE_SOON: 'Vence en menos de 24 h',
      REMINDERS: 'Recordatorios',
      REMINDERS_SENT: '{{count}} de 2 enviados',
    },
  },
};
